import { render, staticRenderFns } from "./SectionAlerts.vue?vue&type=template&id=9525c534&scoped=true&"
import script from "./SectionAlerts.vue?vue&type=script&lang=js&"
export * from "./SectionAlerts.vue?vue&type=script&lang=js&"
import style0 from "./SectionAlerts.vue?vue&type=style&index=0&id=9525c534&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9525c534",
  null
  
)

export default component.exports